import AnessaListItemUtil, { AnessaListItem } from '../../anessa-list-item.interface';
import { UnitValue } from '../../data-structures/unit-value.model';
import {v4 as uuid} from 'uuid';
import { InputSummary, InputSummaryItem } from '../../input-summary';
import InputSummaryUtils from '../../../helper/input-summary/input-summary-util';

export interface AdditionalProductInterface {
  _id: string;
  name: string;
  uuid: string;
  description: string;
  priceType: string;
  price: UnitValue;
  pricePer: UnitValue;
  cpi: UnitValue;
  quantity: UnitValue;
  quantityPer: UnitValue;
  parentProduct: string;
}


export class AdditionalProduct implements AnessaListItem{
  _id: string;
  name: string;
  uuid: string;
  description: string;
  priceType: string;
  price: UnitValue;
  pricePer: UnitValue;
  cpi: UnitValue;
  quantity: UnitValue;
  quantityPer: UnitValue;
  parentProduct: string;

  constructor(param: AdditionalProductInterface = {
    _id: null,
    name: null,
    uuid: null,
    description: null,
    priceType: null,
    price: new UnitValue(),
    pricePer: new UnitValue(),
    cpi: new UnitValue(),
    quantity: new UnitValue(),
    quantityPer: new UnitValue(),
    parentProduct: null
  }){
      this._id = param._id;
      this.name = param.name;
      this.uuid = param.uuid ? param.uuid : uuid();
      this.description = param.description;
      this.priceType = param.priceType;
      this.price = new UnitValue(param.price);
      this.pricePer = new UnitValue(param.pricePer);
      this.cpi = new UnitValue(param.cpi);
      this.quantity = new UnitValue(param.quantity);
      this.quantityPer = new UnitValue(param.quantityPer);
      this.parentProduct = param.parentProduct;
  }


  getInputSummary(path: string[]) {
    const inputSummary = new InputSummary();
    inputSummary.inputs = this.getSummaryInputs(path);
    return inputSummary;
  }


  getSummaryInputs(path: string[]) {
    let inputs: InputSummaryItem[] = [];
    inputs = InputSummaryUtils.performPush(inputs, AddProdPropName.name, this.name, [...path, 'name']);
    inputs = InputSummaryUtils.performPush(inputs, AddProdPropName.description, this.description, [...path, 'description']);
    inputs = InputSummaryUtils.performPush(inputs, AddProdPropName.priceType, this.priceType, [...path, 'priceType']);
    inputs = InputSummaryUtils.performPush(inputs, AddProdPropName.price, this.price, [...path, 'price']);
    inputs = InputSummaryUtils.performPush(inputs, AddProdPropName.pricePer, this.pricePer, [...path, 'pricePer']);
    inputs = InputSummaryUtils.performPush(inputs, AddProdPropName.quantity, this.quantity, [...path, 'quantity']);
    inputs = InputSummaryUtils.performPush(inputs, AddProdPropName.quantityPer, this.quantityPer, [...path, 'quantityPer']);
    inputs = InputSummaryUtils.performPush(inputs, AddProdPropName.parentProduct, this.parentProduct, [...path, 'parentProduct']);
    return inputs;
  }


  getUuidForPath(): string {
    return AnessaListItemUtil.getUuidForPath(this.uuid);
  }


  static deepCopy(product: AdditionalProduct): AdditionalProduct {
    let copy = null;
    if (product) {
      copy = new AdditionalProduct(product);
      return copy;
    }
    throw new Error('Product copy failed');
  }


  /**
   * Returns a copy of the provided array of products while keeping their types.
   * @param additionalProducts is an array of Product objects.
   */
  static arrayDeepCopy(additionalProducts: AdditionalProduct[]) {
    const copy: AdditionalProduct[] = [];
    if (additionalProducts && additionalProducts.length) {
      for (const product of additionalProducts) {
        copy.push(new AdditionalProduct(product));
      }
    }
    return copy;
  }
}

export enum AddProdPropName {
  name = 'name',
  description = 'description',
  priceType = 'priceType',
  price = 'price',
  pricePer = 'pricePer',
  cpi = 'cpi',
  quantity = 'quantity',
  quantityPer = 'quantityPer',
  parentProduct = 'parentProduct',
  inRelationTo = 'inRelationTo',
  id_name = 'name',
  id_description = 'description',
  id_priceType = 'priceType',
  id_price = 'price',
  id_pricePer = 'pricePer',
  id_cpi = 'cpi',
  id_quantity = 'quantity',
  id_quantityPer = 'quantityPer',
  id_parentProduct = 'parentProduct',
  id_inRelationTo = 'inRelationTo'
}



export enum AdditionalProductFeeType {
  INCOME = 'income',
  COST = 'cost',
  FREE = 'free',
  TIPPING_FEE = 'tipping fee'
}


export enum AdditionalProductPriceType {
  BIOMETHANE = 'biomethane',
  WHOLE = 'whole digestate',
  SOLID = 'solid digestate',
  THIN = 'thin digestate',
  DEFAULT = 'please select',
  THERMAL = 'thermal',
  ELECTRIC = 'Electricity',
  RNG = 'RNG'

}